/* eslint-disable no-param-reassign */

import { getCurrentScope } from 'client/utils/profiler/profiler';

function transform(timing, baseTime) {
  Object.keys(timing).forEach(key => {
    if (key === 'name') {
      // name property is useful for plat team developer if debugging this feature,
      // but not really useful to product team developer
      delete timing[key];
    } else if (key === 'startTime' || key === 'endTime') {
      timing[key] -= baseTime; // transform Date.now() to time elapsed since server start time
    } else if (typeof timing[key] === 'object' && timing[key] !== null) {
      transform(timing[key], baseTime);
      timing.subtreeHeight = Math.max(timing[key].subtreeHeight + 1, timing.subtreeHeight || 0);
    }
  });
  timing.subtreeHeight = 'subtreeHeight' in timing && timing.subtreeHeight != null ? timing.subtreeHeight : 0;
  return timing;
}

/**
 * Calculate max Chain Depth
 *
 * @param  {number} state profiler state
 * @param  {number} action current action
 */
const getWaterfallLevel = (state, action) => {
  let endingWaterfallLevel = state[getCurrentScope()].endingWaterfallLevel;

  if (action.timing.endingWaterfallLevel) {
    endingWaterfallLevel = Math.max(action.timing.endingWaterfallLevel, endingWaterfallLevel);
  }

  return endingWaterfallLevel;
};

/**
 * timings
 *
 * @param  {Object} state  Current state
 * @param  {Object} action State update action
 * @return {Object}        New state
 */
export function profilerReducer(state = {}, action = {}) {
  const scope = getCurrentScope();
  const stateToUse = state[scope] ?? {};

  switch (action.type) {
    case 'PROFILER_ACTION_PRELOADER_UPDATE': {
      const relStartTime = action.timing.startTime - action.requestStartTime;
      const relEndTime = action.timing.endTime - action.requestStartTime;
      const key = `preloader.load()-${relStartTime}-${relEndTime}`;

      const endingWaterfallLevel = getWaterfallLevel(state, action);

      const transformed = transform(action.timing, action.requestStartTime);
      /*
      next, transform
      from: 'preloader.load()-x':       to: 'preloader.load()-x':
              subtreeHeight: 2,               maxSubtreeHeight: 1,
              'resolve-y':                      'resolve-y':
                subtreeHeight: 1,                 subtreeHeight: 1,
       */
      transformed.maxSubtreeHeight = transformed.subtreeHeight - 1;
      delete transformed.subtreeHeight;
      const newState = {
        ...state,
        [scope]: {
          ...stateToUse,
          [key]: transformed,
          endingWaterfallLevel,
        },
      };

      return newState;
    }
    case 'PROFILER_ACTION_CMP_UPDATE': {
      const { componentName } = action;
      const profilerName = `component-${componentName}`;

      const endingWaterfallLevel = getWaterfallLevel(state, action);

      const transformed = transform(action.timing, action.requestStartTime);
      const newState = {
        ...state,
        [scope]: {
          ...stateToUse,
          [profilerName]: {
            ...state[profilerName],
            ...transformed,
          },
          endingWaterfallLevel,
        },
      };

      return newState;
    }
    default:
      return state;
  }
}
